import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  news: NewsItem;
  layout?: "vertical" | "horizontal";
}

export default function NewsCard({ news, layout = "vertical" }: NewsCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/news/${news.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 md:p-4 transition-colors hover:border-primary-300"
      >
        <div className="w-28 h-20 md:w-40 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-100">
          <img
            src={news.cover}
            alt={news.title}
            title={`${news.title} 欧冠资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex flex-col">
          <span className="text-xs font-semibold text-accent-600 mb-1">{news.category}</span>
          <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
            {news.title}
          </h3>
          <p className="mt-1.5 text-xs md:text-sm text-foreground-600 line-clamp-2 hidden sm:block">
            {news.summary}
          </p>
          <span className="mt-auto pt-2 text-xs text-foreground-500">
            {news.date} · {news.readMinutes} 分钟阅读
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${news.id}`}
      className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-colors hover:border-primary-300"
    >
      <div className="w-full h-44 md:h-48 overflow-hidden bg-background-100">
        <img
          src={news.cover}
          alt={news.title}
          title={`${news.title} 欧冠资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 flex flex-col p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2">
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-semibold text-secondary-900">
            {news.category}
          </span>
          <span className="text-xs text-foreground-500">{news.date}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {news.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-3">{news.summary}</p>
        <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
          <span>{news.author}</span>
          <span className="inline-flex items-center gap-1 text-primary-600 font-semibold">
            阅读全文
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}